module.exports = ['$rootScope', '$state', '$stateParams', '$filter', function ($scope, $state, $stateParams, $filter) {
    var sortOptions = window.MG.sortOptions;

    // this is duplicated for now
    var initializeSelectFacet = function (facetName, facetOptions, defaultOption) {
        var facetSetName = facetName + 'Set';
        var resetToDefault = true;

        // build an array of all options that should be in dropdown
        $scope[facetSetName] = [];
        angular.forEach(facetOptions, function (x) {
            if (typeof (x) == 'object') {
                $scope[facetSetName].push(x);
            } else {
                $scope[facetSetName].push({
                    name: x.replace('-', ' '),
                    id: x.toLowerCase()
                });
            }
        });

        // adds in a default option as first item in dropdown
        if (typeof (defaultOption) === 'object' && defaultOption !== null) {
            $scope[facetSetName].unshift(defaultOption);
        }

        // set the dropdown based on url otherwise just use the first option
        if (typeof ($stateParams[facetName]) !== 'undefined') {
            angular.forEach($scope[facetSetName], function (value, index) {
                if ($stateParams[facetName] === value.id) {
                    $scope[facetName] = $scope[facetSetName][index];
                    resetToDefault = false;
                }
            });
        }
        if (resetToDefault) {
            $scope[facetName] = $scope[facetSetName][0];
        }
    };

    var initializeTextFacet = function (facetName) {
        var facetInputName = facetName + 'Input';

        if (typeof ($stateParams[facetName]) !== 'undefined') {
            $scope[facetName] = $stateParams[facetName];
            $scope[facetInputName] = $stateParams[facetName];
        } 
        $scope.$watch(facetName, function (newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }

            if (newVal === '') {
                newVal = null;
            }
            $stateParams[facetName] = newVal;
            window.localStorage.setItem('MG.previousCount', '0');
            $state.go('search', $stateParams, { reload: true });
        });
    };

    // initialize facets
    initializeSelectFacet('sort', sortOptions);
    initializeTextFacet('text');

    // handle search text change
    $scope.updateSearchText = function ($event) {
        $scope.text = $scope.textInput;
    };

    $scope.clickTypeAheadItem = function ($event, text) {
        $event.preventDefault();
        $scope.text = $scope.textInput = text;
    };

    $scope.items = window.MG.productNames;

    $scope.tags = [];

    // update tags
    angular.forEach(Object.keys($stateParams), function (facetName) {
        var facetValue = $scope[facetName];
        var activeColors = [];

        if (typeof ($stateParams[facetName]) === 'undefined') {
            return;
        }

        if (facetName === 'sort') {
            return;
        }

        if (facetName === 'colors') {
            activeColors = $stateParams[facetName].split(',');

            activeColors = $filter('filter')($scope.colorsSet, function (x) {
                return activeColors.indexOf(x.id) !== -1;
            });

            angular.forEach(activeColors, function (x) {
                $scope.tags.push({
                    facet: facetName,
                    type: 'multiOption',
                    value: x.id,
                    name: x.name
                });
            });
        } else if (typeof (facetValue) === 'string' && facetValue !== '' && facetName !== 'heightMin' && facetName !== 'lengthMin') {
            $scope.tags.push({
                facet: facetName,
                type: 'text',
                value: facetValue,
                name: facetValue
            });
        } else if (typeof (facetValue) === 'object' && facetValue.id !== 'all') {
            $scope.tags.push({
                facet: facetName,
                type: 'select',
                value: facetValue.id,
                name: facetValue.name
            });
        } else if (facetName === 'priceMin' || facetName === 'priceMax' && $filter('filter')($scope.tags, { facet: 'priceMin,priceMax' }).length === 0) {
            $scope.tags.push({
                facet: 'priceMin,priceMax',
                type: 'slider',
                value: '$' + $scope.priceMin + ' - $' + $scope.priceMax,
                name: '$' + $scope.priceMin + ' - $' + $scope.priceMax
            });
        } else if (facetName === 'heightMin') {
            $scope.tags.push({
                facet: 'heightMin,lengthMin',
                type: 'text',
                value: $scope.lengthMin + '" x ' + $scope.heightMin + '"',
                name: $scope.lengthMin + '" x ' + $scope.heightMin + '"'
            });
        } else if (facetName === 'movementMin' || facetName === 'movementMax' && $filter('filter')($scope.tags, { facet: 'movementMin,movementMax' }).length === 0) {
            $scope.tags.push({
                facet: 'movementMin,movementMax',
                type: 'slider',
                value: $scope.movementMin + ' - ' + $scope.movementMax,
                name: 'Movement: ' + $scope.movementMin + ' - ' + $scope.movementMax
            });
        } else if (facetName === 'colorRangeMin' || facetName === 'colorRangeMax' && $filter('filter')($scope.tags, { facet: 'colorRangeMin,colorRangeMax' }).length === 0) {
            $scope.tags.push({
                facet: 'colorRangeMin,colorRangeMax',
                type: 'slider',
                value: $scope.colorRangeMin + ' - ' + $scope.colorRangeMax,
                name: 'Color Range: ' + $scope.colorRangeMin + ' - ' + $scope.colorRangeMax
            });
        }
    });

    $scope.removeFacet = function (removedFacet) {
        var facetName = removedFacet.facet;
        var facetType = removedFacet.type;
        var facetSetName = removedFacet.facet + 'Set';
        var activeOptions = [];

        if (facetType === 'multiOption') {
            angular.forEach($scope[facetSetName], function (x) {
                if (removedFacet.value === x.id) {
                    x.active = false;
                };
                if (x.active) {
                    activeOptions.push(x.id);
                }
            });

            if (activeOptions.length === 0) {
                $scope[facetName] = null;
            } else {
                $scope[facetName] = activeOptions.join(',');
            }
        } else if (facetType === 'text') {
            for (var i = 0; i < facetName.split(',').length; i++) {
                $scope[facetName.split(',')[i] + 'Input'] = '';
                $scope[facetName.split(',')[i]] = '';
            }
            if (facetName === 'heightMin,lengthMin') {
                $stateParams['heightMin'] = null;
                $stateParams['lengthMin'] = null;
                window.localStorage.setItem('MG.previousCount', '0');
                $state.go('search', $stateParams, { reload: true });
            }

        } else {
            for (var i = 0; i < facetName.split(',').length; i++) {
                $stateParams[facetName.split(',')[i]] = null;
            }
            window.localStorage.setItem('MG.previousCount', '0');
            $state.go('search', $stateParams, { reload: true });
        }
    };
}];
